import { Flex, Text } from "@radix-ui/themes";
import Link from "next/link";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { navigationMenuTriggerStyle } from "../ui/navigation-menu";
import { useState } from "react";
import { Role } from "@prisma/client";
import { signOut } from "next-auth/react";
import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";
import { ChevronDownIcon } from "@radix-ui/react-icons";

import { AccordionItem, AccordionTrigger, AccordionContent } from "../ui/accordion";
import { SheetClose } from "../ui/sheet";

const AuthStatusButton = ({
  session,
  navButtonStyle,
  variant = "dropdown",
  closeOnItemClick = false,
}: {
  session: any;
  navButtonStyle: string;
  variant?: "dropdown" | "accordion";
  closeOnItemClick?: boolean;
}) => {
  const [loggingOut, setLoggingOut] = useState(false);

  if (variant === "accordion") {
    return (
      <AccordionItem value="account" className="border-white">
        <AccordionTrigger className={cn(navigationMenuTriggerStyle(), navButtonStyle, "w-full px-4")}>
          <Flex justify="start" className="w-full">Account</Flex>
        </AccordionTrigger>
        <AccordionContent>
          <div className="flex flex-col space-y-3 px-5 pt-3">
            {session.role === Role.BUYER && (
              <>
                {closeOnItemClick ? (
                  <SheetClose asChild>
                    <Link href="/watchlist">Watchlist</Link>
                  </SheetClose>
                ) : (
                  <Link href="/watchlist">Watchlist</Link>
                )}
                {closeOnItemClick ? (
                  <SheetClose asChild>
                    <Link href="/account/details">Account Settings</Link>
                  </SheetClose>
                ) : (
                  <Link href="/account/details">Account Settings</Link>
                )}
              </>
            )}
            <button
              onClick={() => {
                setLoggingOut(true);
                signOut({ callbackUrl: "/" });
              }}
              className="text-left"
            >
              <Flex justify="between" align="center">
                <Text>Log Out</Text>
                {loggingOut && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              </Flex>
            </button>
          </div>
        </AccordionContent>
      </AccordionItem>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <Flex
          align="center"
          className={cn(navigationMenuTriggerStyle(), navButtonStyle, "gap-1")}
        >
          <Text>
            Account
          </Text>
          <ChevronDownIcon />
        </Flex>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuLabel>
          <Text size="2">{session!.user!.email}</Text>
        </DropdownMenuLabel>
        {session.role === Role.BUYER && (
          <>
            <DropdownMenuItem asChild>
              <Link href="/watchlist">Watchlist</Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link href="/account/details">Account Settings</Link>
            </DropdownMenuItem>
          </>
        )}
        <DropdownMenuItem asChild>
          <Flex
            justify="between"
            align="center"
            onClick={() => {
              setLoggingOut(true);
              signOut({ callbackUrl: "/" });
            }}
          >
            <Text>Log Out</Text>
            {loggingOut && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          </Flex>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default AuthStatusButton;
